import { AuditLog as ReusableAuditLog } from "~/components/Auditlog/Auditlog";
import { SpaceScope } from "~/hooks/useScope";

export type AuditLogProps = {
  space: SpaceScope;
};

export function AuditLog({ space }: AuditLogProps) {
  return (
    //AuditLog is being reused in both the space and org level
    <ReusableAuditLog {...{ resourceMrn: space.mrn }} />
  );
}
